import React from 'react';
import './Button.css';

const onMouseEnter = (event, color, bgColor) => {
  const el = event.target;
  el.style.color = color;
  el.style.backgroundColor = bgColor;
};

const onMouseOut = (event, color, bgColor) => {
  const el = event.target;
  el.style.color = color;
  el.style.backgroundColor = bgColor;
};

export default function Button({ text, className, href, newTab }) {
  return (
    <div className={className}>
      <a
        class='main-button'
        href={href}
        target={newTab && '_blank'}
        style={{
          color: '#d5d8dc',
          backgroundColor: '#000000',
          border: `solid 1px #000000`,
        }}
        onMouseEnter={(event) => onMouseEnter(event, '#000000', '#d5d8dc')}
        onMouseOut={(event) => onMouseOut(event, '#d5d8dc', '#000000')}
      >
        {text}
      </a>
    </div>
  );
}
